import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterList'
})
export class FilterListPipe implements PipeTransform {

  transform(value: any[], args?: any): any {
    const {term, fields} = args;
    if(!term) return value;
    
    const result = value.filter(
      (element) => {
        for (let index = 0; index < fields.length; index++) {
          // const value = element[fields[index]];
          const value = eval('element.'+fields[index]);//[fields[index]];
          // console.log(value);
          if(value && value.toLowerCase().indexOf(term.toLowerCase()) !== -1){
            return true;
          }
        }
        return false;
      }
    );

    return result;
  }

}
